import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';

import { SharedDirectivesModule } from '@sd-portal/shared/directives';
import { SharedAutocompleteShellModule } from '@sd-portal/shared/autocomplete-shell';
import { UtilModule } from '@sd-portal/shared/util';

import { SharedPassengerService } from './shared-passenger.service';
import { AddPassengerDialogComponent } from './add-passenger-dialog/add-passenger-dialog.component';
import { PassengerAutocompleteComponent } from './passenger-autocomplete/passenger-autocomplete.component';
import { PassengerChipsAutocompleteComponent } from './passenger-chips-autocomplete/passenger-chips-autocomplete.component';
import { SiflGroupLinkComponent } from './sifl-group-link/sifl-group-link.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule.withConfig({
      warnOnNgModelWithFormControl: 'always',
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    SharedDirectivesModule,
    SharedAutocompleteShellModule,
    UtilModule,
    // material
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule
  ],
  declarations: [
    AddPassengerDialogComponent,
    PassengerAutocompleteComponent,
    PassengerChipsAutocompleteComponent,
    SiflGroupLinkComponent
  ],
  exports: [
    AddPassengerDialogComponent,
    PassengerAutocompleteComponent,
    PassengerChipsAutocompleteComponent,
    SiflGroupLinkComponent
  ],
  providers: [SharedPassengerService]
})
export class SharedPassengerModule {}
